import { MultiSelect, Option } from 'carbon-react/esm/components/select';
import { useState, useEffect } from 'react';
import FilterNatureProps from '../types/filternature.types';
import { NATURE_MAPPING } from '../../../types/dsn.types';

export default function NatureFlux({
  onNatureChange,
  selectedNatures,
  placeholder = 'Sélectionner la nature',
  label,
}: Readonly<FilterNatureProps>) {
  const [value, setValue] = useState<string[]>(selectedNatures);
  const natureOptions = NATURE_MAPPING;

  useEffect(() => {
    setValue(selectedNatures);
  }, [selectedNatures]);

  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { value: updatedValue } = ev.target;
    if (Array.isArray(updatedValue)) {
      setValue(updatedValue);
      onNatureChange(updatedValue);
    }
  };

  return (
    <MultiSelect
      id="nature-filter"
      name="nature-filter"
      maxWidth="100%"
      size="small"
      placeholder={placeholder}
      label={label}
      onChange={handleChange}
      value={value}
      style={{ minHeight: '34px', margin: '2px' }}
    >
      {Object.entries(natureOptions).map(([natureKey, natureLabel]) => (
        <Option key={natureKey} text={natureLabel} value={natureKey} />
      ))}
    </MultiSelect>
  );
}
